import { SampleDto } from '../../api/api.ts';
import { SampleConfiguration, SampleConfigurationField } from '../../sampleSets.ts';

export class SampleTableClipboardContent {

    // SampleDto objects representing the copied data
	content: SampleConfiguration[];
	// List of SampleConfoguration fields that were selected during copy 
    selectedFields: SampleConfigurationField[];
	// List of Parameter IDs that were selected during copy
    selectedParameterNames: string[];
	// If no SampleDto objects were found on the clipboard,
	// we possibly fall back to raw text data.
	alternateTextData: string | null;

	constructor() {
		this.content = [];
        this.selectedFields = [];
        this.selectedParameterNames = [];
		this.alternateTextData = null;
	}

	// Accepts an object of class LevelChanges
	fromTable(c:SampleConfiguration[], selectedFields:SampleConfigurationField[], selectedParameterNames:string[]) {
        this.content = c.map((oneConfig) => {
            return oneConfig.clone();
        });
        this.selectedFields = selectedFields;
        this.selectedParameterNames = selectedParameterNames;
    }

	asGridOfValues():any[][] {
		const thisClipboard = this;

		if ((this.content.length == 0) && (this.alternateTextData !== null)) {
			return [[this.alternateTextData]];
		}
		var rows = this.content.map((c) => {
			// Push values for selected fields, then selected parameters, in order found.
			var row:any[] = [];
			thisClipboard.selectedFields.forEach((f) => {
				row.push(thisClipboard.getField(c, f));
			});
			thisClipboard.selectedParameterNames.forEach((n) => {
				row.push(thisClipboard.getParameter(c, n));
			});
			return row;
		});
		return rows;
	}

	getField(c:SampleConfiguration, field:SampleConfigurationField):string | number | null {
		var v = undefined;
		switch(field) {
			case SampleConfigurationField.Name:
				v = c.name
				break;
			case SampleConfigurationField.Description:
				v = c.description
				break;
			case SampleConfigurationField.ScanType:
				v = c.scanTypeSlug
				break;
			default:
				v = c.id;
				break;
			}
		if (v === undefined) { v = null; }
		return v;
	}
	
	getParameter(c:SampleConfiguration, name:string):any {
		var v = c.parameterValuesByName.get(name);
		return v === undefined ? null : v;
	}

	// The object we expect from the clipboard: {
	//	  fromAlsSampleConfigureApp: true
	//    content: SampleConfiguration[]
	//    selectedColumns: string[]
	// }
	fromClipboardPasteEvent(event: React.ClipboardEvent<Element>) {
		this.content = [];
        this.selectedFields = []; 
        this.selectedParameterNames = [];
		this.alternateTextData = null;

        // Can't get data from the event? Leave this object blank.
        if (event.clipboardData === null) { return; }

		const rawPaste = event.clipboardData.getData("text/json");
		var c;
		// If there's any parsing error, this content didn't come from us.
		try {
			c = JSON.parse(rawPaste);
		} catch (e) {
			this.alternateTextData = event.clipboardData.getData("text") || null;
			// We're going to arbitrarily say that raw text is equivalent to a sample name.
	        this.selectedFields = [SampleConfigurationField.Name];
			return;
		}

		// If this isn't set, the content didn't come from us.
		if (!c.fromAlsSampleConfigureApp) { return; }

    	this.content = c.content.map(([dto, values]: [SampleDto, {[key: string]: any}]) => {
			return new SampleConfiguration(dto, values);
		});
        this.selectedFields = c.selectedFields;
        this.selectedParameterNames = c.selectedParameterNames;
	}

	isEmpty() {
		if (this.selectedFields.length + this.selectedParameterNames.length == 0) { return true; }
		if ((this.content.length == 0) && (this.alternateTextData === null)) { return true; }
		return false;
	}

	sendToClipboard(event: React.ClipboardEvent<Element>) {

		if (this.isEmpty()) { return ; }

		const forClipboard = {
			fromAlsSampleConfigureApp: true,
			content: this.content.map((oneConfig) => oneConfig.asDtos()),
			selectedFields: this.selectedFields,
			selectedParameterNames: this.selectedParameterNames
		};

		//const asBlob = new Blob([JSON.stringify(forClipboard)], {type: 'text/plain'});
		//const item = new ClipboardItem({'text/plain': asBlob });

		event.preventDefault();
		event.clipboardData!.setData("text/json", JSON.stringify(forClipboard));

		//navigator.permissions.query({name: 'clipboard-write'}).then((result) => {
		//	if (result.state === 'granted' || result.state === 'prompt') {
		//	navigator.clipboard.write([item]).catch((ex) => { 
		//		console.log(ex) 
		//		} ); 
		//	}
		//});
	}
}
